/** @jsxImportSource @emotion/react */
import { memo } from "react";

import {
  mtgCaptionList,
  mtgGroup,
  mtgList,
  mtgListContents,
} from "assets/css/stylesCss";

import LabelWithOptionIcon from "components/ui/label/LabelWithOptionIcon";
import InputTextHalf from "components/ui/input/InputTextHalf";

/**
 * 番地・号
 * @param {Boolean} required true : 必須
 *                           false: 任意
 * @param {String} txtCaption キャプション 注釈
 */
const BantGo = memo(({ required, txtCaption }) => {
  return (
    <div css={mtgGroup}>
      {/** ラベル */}
      <LabelWithOptionIcon required={required}>
        番地・号
      </LabelWithOptionIcon>
      <InputTextHalf
        items={[
          {
            name: "bant",
            placeholder: "番地",
            maxLength: 4,
            inputMode: "numeric",
            rules: {
              required: {
                value: required,
                message: "番地を入力してください。",
              },
              pattern: {
                value: /^\d{1,}$/,
                message: "番地は半角数字で入力してください。",
              },
            },
          },
          {
            name: "go",
            placeholder: "号",
            maxLength: 9,
            rules: {
              pattern: {
                value: /^\d{1,}$|^\d{1,4}-{1}\d{1,4}$/,
                message: "号は半角数字で入力してください。",
              },
            },
          },
        ]}
      ></InputTextHalf>
      <ul css={mtgCaptionList}>
        {txtCaption.map((item, index) => (
          <li key={index}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
});

export default BantGo;
